import React from 'react';

export default function ForgotPassword (props) {
  return (
    <>
      <h1>ForgotPassword</h1>
    </>
  );
}
